import { styled } from '@mui/material/styles';

export const CardContainer = styled('div')<{ isSaved?: boolean }>(
    ({ isSaved, theme }) => `
    border: 1px solid ${theme.palette.grey[200]};
    border-radius: 20px;
    padding: 16px;
    margin-bottom: 16px;
    background-color: #fff;
    ${isSaved ? 'cursor: pointer;' : ''}
`,
);

export const CardHeader = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;

export const CardHeaderLeft = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
`;

export const CardTextWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const SaveButtonWrapper = styled('div')`
    display: flex;
    justify-content: center;
    padding-top: 16px;
`;
